import { waitAsync } from '../utils';
import { Route } from 'react-router-dom';

const ListCreditCardPaymentsAction = "LIST_CREDIT_CARD_PAYMENTS";
const ListCreditCardPaymentsDailyAction = "LIST_CREDIT_CARD_PAYMENTS_DAILY";
const Waiting = "WAITING";

const initialState = {
    list: [],
    listDaily: [],
    nowWainting: false,
    editing: null,
    creditCardPaymentTotal: null,
};
export const actionCreators = {
    /**
     * クレジットカードの売上明細リストを取得します。
     */
    listCreditCardPayments: (token, startDt, endDt, issuerId, paymentAgencyId, creditCardPaymentKind) => async (dispatch) => {
        const routeurl = `api/user/creditCardPayments/list`;

        var param = '';
        if (startDt != "" && startDt != null && startDt != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            const sdt = new Date(startDt);
            sdt.setDate(sdt.getDate());
            let dt = sdt.getFullYear() + '/' + ("0" + (sdt.getMonth() + 1)).slice(-2) + '/' + ("0" + sdt.getDate()).slice(-2);
            param += `sdt=${dt}`;
        }
        if (endDt != "" && endDt != null && endDt != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            const edt = new Date(endDt);
            edt.setDate(edt.getDate());
            let dt = edt.getFullYear() + '/' + ("0" + (edt.getMonth() + 1)).slice(-2) + '/' + ("0" + edt.getDate()).slice(-2);
            param += `edt=${dt}`;
        }
        if (issuerId != "" && issuerId != null && issuerId != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            param += `issuerId=${issuerId}`;
        }
        if (paymentAgencyId != "" && paymentAgencyId != null && paymentAgencyId != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            param += `agencyId=${paymentAgencyId}`;
        }
        if (creditCardPaymentKind != "" && creditCardPaymentKind != null && creditCardPaymentKind != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            param += `kind=${creditCardPaymentKind}`;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl + param, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const temp = await response.json();
                // 明細行を取得
                const list = temp.filter(x => x.credit_card_issuer_id != null);
                // 合計行を取得
                const total = temp.filter(x => x.credit_card_issuer_id == null);
                var paymentTotal = '';
                if (total.length > 0) {
                    // 合計値を取得
                    // ￥マーク、カンマ処理
                    paymentTotal = Number(total[0].credit_card_payment).toLocaleString('ja-JP', { "style": "currency", "currency": "JPY" });
                }
                dispatch({ type: ListCreditCardPaymentsAction, list, creditCardPaymentTotal: paymentTotal });
                return list;
            } else {
                throw new Error('クレジットカードの売上明細リストの取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * クレジットカードの売上明細（日別）リストを取得します。
     */
    listCreditCardPaymentsDaily: (token, startDt, endDt, issuerId, paymentAgencyId, creditCardPaymentKind) => async (dispatch) => {
        const routeurl = `api/user/creditCardPayments/list_daily`;

        var param = '';
        if (startDt != "" && startDt != null && startDt != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            const sdt = new Date(startDt);
            sdt.setDate(sdt.getDate());
            let dt = sdt.getFullYear() + '/' + ("0" + (sdt.getMonth() + 1)).slice(-2) + '/' + ("0" + sdt.getDate()).slice(-2);
            param += `sdt=${dt}`;
        }
        if (endDt != "" && endDt != null && endDt != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            const edt = new Date(endDt);
            edt.setDate(edt.getDate());
            let dt = edt.getFullYear() + '/' + ("0" + (edt.getMonth() + 1)).slice(-2) + '/' + ("0" + edt.getDate()).slice(-2);
            param += `edt=${dt}`;
        }
        if (issuerId != "" && issuerId != null && issuerId != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            param += `issuerId=${issuerId}`;
        }
        if (paymentAgencyId != "" && paymentAgencyId != null && paymentAgencyId != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            param += `agencyId=${paymentAgencyId}`;
        }
        if (creditCardPaymentKind != "" && creditCardPaymentKind != null && creditCardPaymentKind != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            param += `kind=${creditCardPaymentKind}`;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl + param, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const listDaily = await response.json();
                dispatch({ type: ListCreditCardPaymentsDailyAction, listDaily: listDaily });
                return listDaily;
            } else {
                throw new Error('クレジットカードの売上明細（日別）リストの取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 一覧を初期化します。
     */
    initListInfo: () => async (dispatch) => {
        dispatch({ type: ListCreditCardPaymentsAction, list: [], nowWainting: false });
    },
}

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === Waiting) {
        return {
            ...state,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === ListCreditCardPaymentsAction) {
        return {
            ...state,
            list: action.list,
            creditCardPaymentTotal: action.creditCardPaymentTotal,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === ListCreditCardPaymentsDailyAction) {
        return {
            ...state,
            listDaily: action.listDaily,
            nowWainting: action.nowWainting
        };
    }
    return state;
}